import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

// Case-insensitive, like the backend (NormalizedName). Pass the names without the currently edited item.
export function UniqueNameValidator(existingNames: () => string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.trim().toUpperCase();
      if (!value) {
        return null;
      }
      const exists = existingNames().some(name => name?.trim().toUpperCase() === value);
      return exists ? {isNotUnique: true} : null;
    };
  }
